import { render } from "./BaoCaoThongKeTinhHinhSDVacxin.vue?vue&type=template&id=75dbb6e9&ts=true"
import script from "./BaoCaoThongKeTinhHinhSDVacxin.vue?vue&type=script&lang=ts"
export * from "./BaoCaoThongKeTinhHinhSDVacxin.vue?vue&type=script&lang=ts"

import "./BaoCaoThongKeTinhHinhSDVacxin.vue?vue&type=style&index=0&id=75dbb6e9&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/CDC/BaoCao/CDC_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__